import Glide from '../../node_modules/@glidejs/glide';
import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from '../../node_modules/photoswipe/dist/photoswipe.esm.js';
import AOS from '../../node_modules/aos/dist/aos.js';
import JSZip, { blob } from '../../node_modules/jszip/dist/jszip.js';
import { saveAs } from '../../node_modules/file-saver/dist/FileSaver.js';

let width = document.body.clientWidth;
let arrayLightbox = [];

// function sha256(message) {
//     const encoder = new TextEncoder();
//     const data = encoder.encode(message);
//     return crypto.subtle.digest("SHA-256", data);
// }

// function toHexString(buffer) {
//     return Array.from(new Uint8Array(buffer))
//       .map(b => b.toString(16).padStart(2, "0"))
//       .join("");
// }

function modalProjectsInit() {
    if (document.querySelectorAll('.js-open-modal-realisation').length > 0) {
        let openModal = document.querySelectorAll('.js-open-modal-realisation');

        for (const modalClick of openModal) {
            modalClick.addEventListener('click', function (e) {
                e.preventDefault();
                let urlToFetch = modalClick.getAttribute('href');
                let modal = document.querySelector(modalClick.dataset.target);
                let loading = document.querySelector('.wrapper-loading');
                loading.classList.add('show');

                fetch(urlToFetch).then(function (response) {
                    return response.text();
                }).then(function (html) {
                    let parser = new DOMParser();
                    doc = parser.parseFromString( html, 'text/html' );
                    modal.querySelector('.wrapper-details').replaceWith(doc.querySelector('.wrapper-details'));
                }).then(function () {
                    generatePhotoSwipe();
                    setTimeout(function () {
                        generateSliders();
                    }, 50);
                }).then(function () {
                    loading.classList.remove('show');
                    modal.classList.add('open');
                    document.querySelector('html').classList.add('overflow-hidden');
                });
            });
        }
    }

    if (document.querySelectorAll('.js-close-modal-project').length > 0) {
        let closeModal = document.querySelectorAll('.js-close-modal-project');

        for (const close of closeModal) {
            close.addEventListener('click', function (e) {
                e.preventDefault();
                let modal = document.querySelector('.modal-project');
                modal.classList.remove('open');
                document.querySelector('html').classList.remove('overflow-hidden');
            });
        }
    }
}

function generateSliders() {
    if (document.querySelectorAll('.slider-glide').length > 0) {
        let sliders = document.querySelectorAll('.slider-glide');
        for (const slider of sliders) {
            setTimeout(() => {
                slider.querySelector('.glide__slides').style.height = slider.offsetHeight + 'px';
            }, 50);
            let glideSlider = new Glide(slider, {
                type: slider.dataset.typeslider ? slider.dataset.typeslider : 'carousel',
                bound: slider.dataset.typeslider === 'carousel' ? false : true,
                perView: slider.dataset.nbslidexxxl ? slider.dataset.nbslidexxxl : "1",
                autoplay: slider.dataset.autoplay !== "0" ? slider.dataset.autoplay : false,
                hoverpause: true,
                animationDuration: slider.dataset.animationduration ? slider.dataset.animationduration : 500,
                animationTimingFunc: "linear",
                gap: slider.dataset.gap ? slider.dataset.gap : 20,
                breakpoints: {
                    1650: {
                        perView: slider.dataset.nbslidexxl
                    },
                    1399: {
                        perView: slider.dataset.nbslidexl
                    },
                    1199: {
                        perView: slider.dataset.nbslidelg
                    },
                    991: {
                        perView: slider.dataset.nbslidemd,
                        gap: 15
                    },
                    767: {
                        perView: slider.dataset.nbslidesm,
                        gap: 15
                    },
                    575: {
                        perView: slider.dataset.nbslide,
                        gap: 15
                    }
                }
            });

            if (!slider.dataset.noresize) {
                setTimeout(function (e) {
                    glideHandleHeight(slider.dataset.id);
                }, 1000)

                glideSlider.on('run.after', function () {
                    glideHandleHeight(slider.dataset.id);
                });
            }

            slider.addEventListener("mouseover", (e) => {
                glideSlider.pause();
            });

            slider.addEventListener("mouseout", (e) => {
                glideSlider.play();
            });

            glideSlider.mount();
        }
    }
}

function generatePhotoSwipe() {
    if (document.querySelectorAll('.photoswipe').length > 0) {
        // let lightboxes = document.querySelectorAll('.photoswipe');
        // for (const lightbox of lightboxes) {
        //     arrayLightbox[lightbox.getAttribute('id')] = new PhotoSwipeLightbox({
        //         gallery: '#' + lightbox.getAttribute('id'),
        //         children: 'a',
        //         pswpModule: PhotoSwipe,
        //     });
        //     arrayLightbox[lightbox.getAttribute('id')].init();   
        // }

        /*
        * Photoswipe
        */
   
        async function prepareImagesForPhotoswipe() {
            // Get the <a> tags from the image gallery
            const imagesList = document.querySelectorAll(".photoswipe a");
            const promisesList = [];
            imagesList.forEach((element) => {
                const promise = new Promise(function (resolve) {
                    let image = new Image();
                    image.src = element.getAttribute('href');
                    image.onload = () => {
                        element.dataset.pswpWidth = image.width;
                        element.dataset.pswpHeight = image.height;
                        resolve(); // Resolve the promise only if the image has been loaded
                    }
                    image.onerror = () => { resolve(); };
                });
                promisesList.push(promise);
            });
            // Wait for all promises to be resolved
            await Promise.all(promisesList);
        }
        
        // Call the function using await
        prepareImagesForPhotoswipe();

        let lightboxes = document.querySelectorAll('.photoswipe');
        for (const lightbox of lightboxes) {
            arrayLightbox[lightbox.getAttribute('id')] = new PhotoSwipeLightbox({
                gallery: '#' + lightbox.getAttribute('id'),
                children: 'a',
                showHideAnimationType: 'zoom',
                showHideOpacity: true, 
                showAnimationDuration: 200,
                pswpModule: PhotoSwipe
            });
            arrayLightbox[lightbox.getAttribute('id')].init();   
        }
    }
}

function eventListenerFilters() {
    let filters = document.querySelectorAll('.filter-link');
    for (const filter of filters) {
        filter.addEventListener("click", (e) => {
            e.preventDefault();
            let loading = document.querySelector('.wrapper-loading');
            loading.classList.add('show');
            let urlToFetch = filter.getAttribute('href');
            fetch(urlToFetch).then(function(response) {
                return response.text();
            }).then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                document.querySelector(".js-container-filters").replaceWith(doc.querySelector(".js-container-filters"));
                eventListenerFilters();
                if (doc.querySelectorAll(".js-product-listing").length > 0) {
                    document.querySelector(".js-product-listing").replaceWith(doc.querySelector(".js-product-listing"));
                } else {
                    document.querySelector(".js-product-listing").innerHTML = "Pas de produits";
                }
                loading.classList.remove('show');
            })
        });
    }
}

function eventListenerFiltersAgencies() {
    let filters = document.querySelectorAll('.filter-link-agencies');
    for (const filter of filters) {
        filter.addEventListener("click", (e) => {
            e.preventDefault();
            let loading = document.querySelector('.wrapper-loading');
            loading.classList.add('show');
            let urlToFetch = filter.getAttribute('href');
            fetch(urlToFetch).then(function(response) {
                return response.text();
            }).then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                document.querySelector(".wrapper-filters-agencies").replaceWith(doc.querySelector(".wrapper-filters-agencies"));
                eventListenerFiltersAgencies();
                if (doc.querySelectorAll(".wrapper-boxes-agencies").length > 0) {
                    document.querySelector(".wrapper-boxes-agencies").replaceWith(doc.querySelector(".wrapper-boxes-agencies"));
                } else {
                    document.querySelector(".wrapper-boxes-agencies").innerHTML = "Pas d'agences";
                }
                loading.classList.remove('show');
            })
        });
    }
}

function eventListenerFiltersBlogs() {
    let filters = document.querySelectorAll('.filter-link-blog');
    for (const filter of filters) {
        filter.addEventListener("click", (e) => {
            e.preventDefault();
            let loading = document.querySelector('.wrapper-loading');
            loading.classList.add('show');
            let urlToFetch = filter.getAttribute('href');
            fetch(urlToFetch).then(function(response) {
                return response.text();
            }).then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                document.querySelector(".wrapper-filters-blogs").replaceWith(doc.querySelector(".wrapper-filters-blogs"));
                eventListenerFiltersBlogs();
                if (doc.querySelectorAll(".blog-listing").length > 0) {
                    document.querySelector(".blog-listing").replaceWith(doc.querySelector(".blog-listing"));
                } else {
                    document.querySelector(".blog-listing").innerHTML = "Pas d'articles";
                }
                loading.classList.remove('show');
            })
        });
    }
}

function eventListenerFiltersProjects() {
    let filters = document.querySelectorAll('.filter-link-project');
    for (const filter of filters) {
        filter.addEventListener("click", (e) => {
            e.preventDefault();
            let loading = document.querySelector('.wrapper-loading');
            loading.classList.add('show');
            let urlToFetch = filter.getAttribute('href');
            fetch(urlToFetch).then(function(response) {
                return response.text();
            }).then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                document.querySelector(".wrapper-filters-projects").replaceWith(doc.querySelector(".wrapper-filters-projects"));
                eventListenerFiltersProjects();
                if (doc.querySelectorAll(".modal-project").length > 0) {
                    document.querySelector(".modal-project").replaceWith(doc.querySelector(".modal-project"));
                }
                if (doc.querySelectorAll(".projects-listing").length > 0) {
                    document.querySelector(".projects-listing").replaceWith(doc.querySelector(".projects-listing"));
                } else {
                    document.querySelector(".projects-listing").innerHTML = "Pas de réalisation";
                }
            }).then(function() {
                loading.classList.remove('show');
                modalProjectsInit();
            })
        });
    }
}

export function serializeData(form){
    var search_params = new URLSearchParams();
    let inputs = form.querySelectorAll('input,select');
    for(let input of inputs){
        if(input.value.length > 0 && input.getAttribute('name')){
            if(input.type == 'radio'){
                if(input.checked){
                    search_params.append(input.getAttribute('name'), input.value);
                }
            } else{
                search_params.append(input.getAttribute('name'), input.value);
            }
        }
    }
    let query_string = search_params.toString();
    let action = form.getAttribute('action');
    return action+"?"+query_string;
}

function scrollTo(element, offsetElem=100) {
    let bodyRect = document.body.getBoundingClientRect();
    let elemRect = element.getBoundingClientRect();
    let offset = elemRect.top - bodyRect.top;
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: offset - offsetElem - 40
    });
}

// Resize height
function glideHandleHeight(id) {
    let currentSlider = ".slider-" + id;
    let glideTrackHeight = document.querySelector(currentSlider + ' .glide__track');
    let glideSlide = document.querySelectorAll(currentSlider + ' .glide__slide--active img');
    let i;
    for (i = 0; i < glideSlide.length; i++) {
        glideTrackHeight.style.height = glideSlide[i].offsetHeight + "px";
    }
}

async function generateZip(documents) {
    var zip = new JSZip();
    let allDocuments = documents.split(',').filter(elm => elm);
    for (const document of allDocuments) {
        await fetch(document).then(function(response) {
            let nameFile = document.split('/').pop();
            zip.file(nameFile, response.arrayBuffer(), { binary: true });
        });
    }
    return zip;
}

async function createZip(docName, documents, element) { 
    const results = await generateZip(documents);
    results.generateAsync({type:"blob"})
    .then(function(content) {
        // see FileSaver.js
        element.querySelector('.download').classList.remove('d-none');
        element.querySelector('.loader').classList.add('d-none');
        saveAs(content, docName + ".zip");
    });
}

document.addEventListener("DOMContentLoaded", () => {

    AOS.init();

    /* Add Search responsive */

    if (document.querySelectorAll('.wrapper-navigation').length > 0) {
        let openSearch = document.querySelector('.wrapper-navigation');

        let searchButton = document.createElement('span');
        searchButton.classList.add('wp-block-navigation-item', 'wp-block-navigation-link', 'icon-search-responsive');
        searchButton.innerHTML = '<a class="wp-block-navigation-item__content" href="#recherche"><span class="wp-block-navigation-item__label"><img style="width: 17px; margin-top: 4px;" src="/wp-content/themes/eclatec/assets/images/icons/magnifying-glass-regular.svg"></span></a>';
        searchButton.addEventListener("click", (e) => {
            e.preventDefault();
            let search = document.querySelector('.modal-search');
            search.classList.toggle('open');
            search.querySelector('input').focus();
            search.querySelector('input').select();
        });
        openSearch.prepend(searchButton);
    }

    /* Download all files loader */

    if (document.querySelectorAll('.download-all-files').length > 0) {
        let downloadAllFiles = document.querySelectorAll('.download-all-files');
        for (const downloadAllFile of downloadAllFiles) {
            downloadAllFile.addEventListener("click", (e) => {
                e.preventDefault();
                downloadAllFile.querySelector('.download').classList.add('d-none');
                downloadAllFile.querySelector('.loader').classList.remove('d-none');
                createZip(downloadAllFile.dataset.name, downloadAllFile.dataset.documents, downloadAllFile);
            });
        }
    }

    if (document.querySelectorAll('.download-photometrie').length > 0) {
        let downloadPhotometries = document.querySelectorAll('.download-photometrie');
        for (const downloadPhotometrie of downloadPhotometries) {
            downloadPhotometrie.addEventListener("click", (e) => {
                e.preventDefault();
                console.log('download photometrie', downloadPhotometrie.querySelector('.download'));
                downloadPhotometrie.querySelector('.download').classList.add('d-none');
                downloadPhotometrie.querySelector('.loader').classList.remove('d-none');
                createZip(downloadPhotometrie.dataset.name, downloadPhotometrie.dataset.documents, downloadPhotometrie);
            });
        }
    }

    /* TABS */

    if (document.querySelectorAll('.js-tab').length > 0) {
        let tabs = document.querySelectorAll('.js-tab');
        let blockForms = document.querySelectorAll('.block-form');
        for (const tab of tabs) {
            tab.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                let id = tab.getAttribute('href');
                let element = document.querySelector(id);
                for (const blockForm of blockForms) {
                    blockForm.classList.add('d-none');
                }
                for (const tab of tabs) {
                    tab.classList.remove('active');
                }
                tab.classList.add('active');
                element.classList.remove('d-none');
            })
        }
    }

    /* FORMS */

    if (document.querySelectorAll("input[name='your-name']").length > 0) {
        let inputName = document.querySelector("input[name='your-name']");
        let inputFirstname = document.querySelector("input[name='your-firstname']");
        let hidden = document.querySelector("input[name='your-subject']");
        let valueHidden = hidden.value;
        inputName.addEventListener("change", (e) => {
            hidden.value = valueHidden + ' - ' + inputName.value;  
        })
        inputFirstname.addEventListener("change", (e) => {
            hidden.value = valueHidden + ' - ' + inputFirstname.value;  
            if (inputName.value.length > 0) {
                hidden.value = valueHidden + ' - ' + inputName.value + ' ' + inputFirstname.value;  
            }
        })
    }

    /*
    ** Wrapper table
        */
    let tbls = document.querySelectorAll('table');
    for (const tbl of tbls) {
        if (!tbl.classList.contains('no-wrapper')) {
            let parent = tbl.parentNode;
            let wrapper = document.createElement('div');
            wrapper.style.overflowX="auto";
            parent.insertBefore( wrapper, tbl );
            wrapper.appendChild(tbl);
        }
    }

    if (document.querySelectorAll('[href^="#"]').length > 0) {
        let anchors = document.querySelectorAll('[href^="#"]');
        for (const anchor of anchors) {
            anchor.addEventListener("click", (e) => {
                let height = document.querySelector("header").offsetHeight;
                if(document.querySelectorAll(".wrapper-anchors").length > 0){
                    height = height + document.querySelector(".wrapper-anchors").offsetHeight
                }
                e.preventDefault();
                if (document.getElementById(anchor.getAttribute('href').replace('#', ''))) {
                    scrollTo(document.getElementById(anchor.getAttribute('href').replace('#', '')), height);
                }
            });
        }
    }

    /* Lightbox */
    generatePhotoSwipe();

    /* filters products */

    if (document.querySelectorAll('.filter-link').length > 0) {
        eventListenerFilters();
    }

    if (document.querySelectorAll('.filter-link-agencies').length > 0) {
        eventListenerFiltersAgencies();
    }

    if (document.querySelectorAll('.filter-link-blog').length > 0) {
        eventListenerFiltersBlogs();
    }

    if (document.querySelectorAll('.filter-link-project').length > 0) {
        eventListenerFiltersProjects();
    }

    /* Recherche */

    if (document.querySelectorAll('.toggle-search').length > 0) {
        let toggleSearch = document.querySelector('.toggle-search');
        toggleSearch.addEventListener("click", (e) => {
            e.preventDefault;
            let search = document.querySelector('.modal-search');
            search.classList.toggle('open');
            search.querySelector('input').focus();
            search.querySelector('input').select();
        });
    }

    /* Open filters */

    if (document.querySelectorAll('.js-open-filter').length > 0) {
        let openFilters = document.querySelectorAll('.js-open-filter');
        for (const openFilter of openFilters) {
            openFilter.addEventListener("click", (e) => {
                e.preventDefault();
                let filter = document.querySelector('.wrapper-filters');
                if (filter.classList.contains('open')) {
                    filter.classList.remove('open');
                    openFilter.querySelector('span').innerHTML = openFilter.getAttribute('data-open');
                } else {
                    filter.classList.add('open');
                    openFilter.querySelector('span').innerHTML = openFilter.getAttribute('data-close');
                }                
            });
        }
    }

    /*
    * Projects modal
    */

    modalProjectsInit();


    /*
    * Tree
    */

    if (document.querySelectorAll('.event-leaf').length > 0) {
        let leafs = document.querySelectorAll('.event-leaf');
        for (const leaf of leafs) {
            leaf.addEventListener('click', e => {
                e.preventDefault();
                console.log(leaf.getAttribute('data-colorclass'), document.querySelector('.text-leaf.' + leaf.getAttribute('data-colorclass')).classList);
                if (document.querySelector('.text-leaf.' + leaf.getAttribute('data-colorclass')).classList.contains('show')) {
                    document.querySelector('.text-leaf.' + leaf.getAttribute('data-colorclass')).classList.remove('show');
                } else {
                    for (const text of document.querySelectorAll('.text-leaf')) {
                        text.classList.remove('show');
                    }
                    document.querySelector('.text-leaf.' + leaf.getAttribute('data-colorclass')).classList.add('show');
                }

                if (document.body.clientWidth < 1200) {
                    scrollTo(document.querySelector('.text-leaf.' + leaf.getAttribute('data-colorclass')));
                }
            })
        }
    }

    if (document.querySelectorAll('.close-text-leaf').length > 0) {
        let closeLeafs = document.querySelectorAll('.close-text-leaf');
        for (const closeLeaf of closeLeafs) {
            closeLeaf.addEventListener('click', e => {
                e.preventDefault();
                for (const text of document.querySelectorAll('.text-leaf')) {
                    text.classList.remove('show');
                }
            })   
        }
    }
});

window.addEventListener('load', function () {
    /*
    * sliders
    */
   generateSliders();
});

let alreadyPlayed = false;
let numberOfIteration = 1;
window.addEventListener('scroll', function() {
    if (document.querySelectorAll('.number-value').length > 0 && !alreadyPlayed) {
        let elements = document.querySelectorAll('.number-value');
        for (let element of elements) {
            let position = element.getBoundingClientRect();

            // checking whether fully visible
            if(position.top >= 0 && (position.bottom + 100) <= window.innerHeight) {
                    const counter = element;
                    counter.innerText = '0';

                    // Function to update 
                    const updateCounter = () => {
                        // Get the target value from the 'data-target' attribute of the counter element
                        const target = +counter.getAttribute('data-number');

                        // Get the current value of the counter
                        const current = +counter.innerText;

                        // Calculate the increment value
                        const increment = target / 100;

                        // Check if the current value is less than the target value
                        if (current < target) {
                            // Increment the counter value and update the display
                            counter.innerText = `${Math.ceil(current + increment)}`;
                            // Call the updateCounter function again after a short delay (1 millisecond)
                            setTimeout(updateCounter, 15);
                        } else {
                            // If the current value is greater than or equal to the target value, set the counter to the target value
                            counter.innerText = target;
                        }
                    }

                    // Call the updateCounter function to start the counter animation
                    updateCounter();

                numberOfIteration++;
                
                if (numberOfIteration > elements.length) {
                    alreadyPlayed = true;
                }
            }
        }
    }
});

// window.addEventListener('resize', function () {
//     if (document.querySelectorAll('.slider-glide').length > 0) {
//         let sliders = document.querySelectorAll('.slider-glide');
//         for (const slider of sliders) {
//             slider.querySelector('.glide__slides').style.height = 'auto';
//             slider.querySelector('.glide__slides').style.height = slider.offsetHeight + 'px';
//         }
//     }
// })

// document.addEventListener("scroll", (e) => {
  
// });

// document.addEventListener( 'wpcf7mailsent', function( event ) {
//     setTimeout( () => {
//         location = '/';
//     }, 3000 ); // Wait for 3 seconds to redirect.
// }, false );
